import templateUrl from './contact-card.tpl.html';

angular
    .module('festzelt-os.contacts')
    .component('contactCard', {
        bindings: {
            contact: '=',
        },
        controller: [
            'Users',
            function (Users) {
                this.$onInit = () => {
                    this.customerNumberEnabled = _.get(Users, 'state.company.settings.contacts.use_customer_number', false);
                }
            }
        ],
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/pages/contacts/directives/sections/card/contact-card.js